import { Button } from "@mui/material"
import DialogPopup from "components/molecules/DialogPopup"
import AddStudentForm from "components/organisms/forms/AddStudentForm"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"


const AddStudent: FC = () => {
    const { t } = useTranslation()    
    const [popupOpen, setPopupOpen] = useState(false)
    
    return (<>
        <Button
            variant='contained'
            color='primary'
            aria-haspopup='true'
            disableElevation
            onClick={() => {setPopupOpen(true)}}
        >
            <span>{t('dashboard.add-a-new-student')}</span>
        </Button>


        <DialogPopup
            title={t('common.student-onboarding')}
            open={popupOpen}
            onClose={() => setPopupOpen(false)}
            popupWidth={'1000px'}
        >
            <AddStudentForm />
        </DialogPopup>
    </>)
}
export default AddStudent
